/**
 * Global Error Logger
 * Catches unhandled errors and logs them
 */

import { config } from '../Environment';

interface ErrorLog {
  message: string;
  stack?: string;
  url: string;
  userAgent: string;
  timestamp: string;
  type: 'error' | 'unhandledrejection' | 'react';
}

export const initErrorLogger = () => {
  // Catch unhandled JavaScript errors
  window.addEventListener('error', (event) => {
    const errorLog: ErrorLog = {
      message: event.message,
      stack: event.error?.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      type: 'error',
    };

    console.error('[Global Error]:', errorLog);
    logErrorToBackend(errorLog);
  });

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const errorLog: ErrorLog = {
      message: event.reason?.message || String(event.reason),
      stack: event.reason?.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      type: 'unhandledrejection',
    };

    console.error('[Unhandled Rejection]:', errorLog);
    logErrorToBackend(errorLog);
  });

  console.log('✅ Error logger initialized');
};

async function logErrorToBackend(errorLog: ErrorLog) {
  try {
    // Only log in production or if you want to test
    if (process.env.NODE_ENV !== 'production') {
      console.log('[Would log to backend]:', errorLog);
      return;
    }

    // Send to your analytics endpoint
    await fetch(`${config.API_BASE}/api/analytics/event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eventName: 'client_error',
        eventData: errorLog,
        timestamp: errorLog.timestamp,
        userAgent: errorLog.userAgent,
        url: errorLog.url,
      }),
    });
  } catch (error) {
    // Don't let error logging cause more errors
    console.error('Failed to log error to backend:', error);
  }
}
